import _ from 'lodash';
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    grondvog: {
        loading: true,
        error: {},
        data: null
    },
    layers: {
        loading: true,
        error: {},
        data: []
    },
    layersmetadata: {
        loading: true,
        error: {},
        data: []
    },
    layerSettingsDropdown: [],
    layersAkief: [],
    overlayevents: {
        // onMouseMove: (event) => console.log("==> mousemove", event)
    },
    infowindowlayer: null,
    eventlisternerbind: false,
    cleanbindedcomponent: false
};

const initKryGrondvog = (state, action) => {
    return updateObject(state, {
        data: {...state.grondvog, loading: true }
    });
};

const setGrondvog = (state, action) => {
    return updateObject(state, { grondvog: {...state.grondvog, data: action.data, loading: false } });
};

const getGrondvogFailed = (state, action) => {
    return updateObject(state, { grondvog: {...state.grondvog, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false } });
};

const toggleLayerSettingsDropdown = (state, action) => {
    let tempActiveItems = [...state.layerSettingsDropdown];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
    } else {
        tempActiveItems.push(action.key);
    }
    return updateObject(state, { layerSettingsDropdown: tempActiveItems });
};

const initKryLayerlys = (state, action) => {
    return updateObject(state, {
        layersmetadata: {...state.layersmetadata, loading: true }
    });
};

const setLayerlys = (state, action) => {
    return updateObject(state, { layersmetadata: {...state.layersmetadata, data: action.data, loading: false } });
};

const getLayerlysFailed = (state, action) => {
    return updateObject(state, { layersmetadata: {...state.layersmetadata, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false } });
};

const bindComponent = (state, action) => {
    return updateObject(state, { cleanbindedcomponent: false });
};

const kiesLayer = (state, action) => {
    let cleanbindedcomponent = state.cleanbindedcomponent;
    let tempActiveItems = [...state.layersAkief];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
        cleanbindedcomponent = true;
    } else {
        tempActiveItems.push(action.key);
        const newlayersmetadata = [...state.layersmetadata.data];
        var mustIBind = false;
        for (var layer of newlayersmetadata) {
            if (layer.id === action.key) {
                for (var tipe of layer.layertipes) {
                    if (tipe.infooverlay) {
                        mustIBind = true;
                    }
                }
            }
        }
    }
    return updateObject(state, { cleanbindedcomponent: cleanbindedcomponent, eventlisternerbind: mustIBind, layersAkief: tempActiveItems });
};

const setLayers = (state, action) => {
    let newdata = [action.data];
    let historydata = [...state.layers.data];
    for (var i = 0; i < newdata.length; ++i) {
        var updateItem = newdata[i];
        if (historydata.length > 0) {
            for (var j = 0; j < historydata.length; ++j) {
                if (historydata[j].id === updateItem.id) {
                    historydata[j] = updateItem;
                } else {
                    historydata.push(updateItem);
                }
            }
        } else {
            historydata = [...newdata];
        }
    }
    return updateObject(state, { layers: {...state.layers, data: historydata, loading: false } });
};

const removeLayer = (state, action) => {
    var finaldata = state.layers.data.filter((obj) => {
        return obj.id !== action.key;
    });
    return updateObject(state, { layers: {...state.layers, data: finaldata, loading: false } });
}

const changeLayertipe = (state, action) => {
    let cleanbindedcomponent = state.cleanbindedcomponent;
    var tempoverlayevents;
    const newlayersmetadata = [...state.layersmetadata.data];
    var mustIBind = false;
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (var tipe of layer.layertipes) {
                if (tipe.type === action.tipe && tipe.key === action.layerkey) {
                    if (tipe.infooverlay) {
                        mustIBind = true;
                    }
                    tipe.active = true;
                } else {
                    tipe.active = false;
                    cleanbindedcomponent = true;
                }
            }
        }
    }
    return updateObject(state, { cleanbindedcomponent: cleanbindedcomponent, eventlisternerbind: mustIBind, layersmetadata: {...state.layersmetadata, data: newlayersmetadata }, overlayevents: {...state.overlayevents, ...tempoverlayevents } });
}

const changeLayerFilter = (state, action) => {
    let newlayersmetadata = _.cloneDeep(state.layersmetadata.data);
    for (let layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (let tipe of layer.filters) {
                if (tipe.type === action.tipe) {
                    tipe.filterdata = action.nuwewaarde;
                }
            }
        }
    }
    return updateObject(state, { layersmetadata: {...state.layersmetadata, data: newlayersmetadata } });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.INIT_GRONDVOG:
            return initKryGrondvog(state, action);
        case actionTypes.SET_GRONDVOG:
            return setGrondvog(state, action);
        case actionTypes.GET_GRONDVOG_FAILED:
            return getGrondvogFailed(state, action);
        case actionTypes.LAYERSETTINGS_TOGGLE:
            return toggleLayerSettingsDropdown(state, action);
        case actionTypes.INIT_LAYERSLYS:
            return initKryLayerlys(state, action);
        case actionTypes.SET_LAYERSLYS:
            return setLayerlys(state, action);
        case actionTypes.GET_LAYERSLYS_FAILED:
            return getLayerlysFailed(state, action);
        case actionTypes.KIES_LAYER:
            return kiesLayer(state, action);
        case actionTypes.SET_LAYERSAKTIEF:
            return setLayers(state, action);
        case actionTypes.REMOVE_LAYER:
            return removeLayer(state, action);
        case actionTypes.CHANGE_LAYERTIPE:
            return changeLayertipe(state, action);
        case actionTypes.CHANGE_LAYERFILTER:
            return changeLayerFilter(state, action);
        case actionTypes.BIND_COMPONENT:
            return bindComponent(state, action);
        default:
            return state;
    }
};

export default reducer;